export const Hotel = "hotel";
export const TourismCompany = "tourism company";
